export default function installMagnificFocusTrapFix() {
  if (window.__ipp_mfp_focus_fix_installed) return;
  window.__ipp_mfp_focus_fix_installed = true;

  const IPP_ID = "inpostpay-widget-popup";

  const $ = window.jQuery;
  if (!$) return;

  const getMfp = () => ($.magnificPopup ? $.magnificPopup.instance : null);

  let disabled = false;
  let savedHandlers = null;

  const readHandlers = () => {
    const data = $._data(document, "events");
    const focusin = data && data.focusin ? data.focusin : [];
    return focusin.filter((h) => h && h.namespace === "mfp" && typeof h.handler === "function");
  };

  const disable = () => {
    const mfp = getMfp();
    if (disabled) return;
    if (!mfp || !mfp.isOpen) return;
    if (!document.getElementById(IPP_ID)) return;

    savedHandlers = readHandlers();
    $(document).off("focusin.mfp");
    disabled = true;
  };

  const restore = () => {
    if (!disabled) return;

    disabled = false;

    const mfp = getMfp();
    if (!mfp || !mfp.isOpen) {
      savedHandlers = null;
      return;
    }

    if (savedHandlers && savedHandlers.length) {
      for (const h of savedHandlers) {
        $(document).on("focusin.mfp", h.handler);
      }
    }

    savedHandlers = null;
  };

  if (document.getElementById(IPP_ID)) disable();

  const observer = new MutationObserver((mutations) => {
    for (const m of mutations) {
      for (const n of m.addedNodes) {
        if (n && n.nodeType === 1 && n.id === IPP_ID) {
          disable();
        }
      }
      for (const n of m.removedNodes) {
        if (n && n.nodeType === 1 && n.id === IPP_ID) {
          restore();
        }
      }
    }
  });

  if (document.body) {
    observer.observe(document.body, { childList: true });
  } else {
    document.addEventListener("DOMContentLoaded", () => {
      observer.observe(document.body, { childList: true });
    }, { once: true });
  }
}
